import { Box, Grid, Typography, Button } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { useState, useEffect, ChangeEvent } from 'react';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: 24,
  },
  title: {
    marginBottom: 24,
  },
  subtitle: {
    marginBottom: 24,
  },
  addButton: {
    marginTop: 24,
  }
}));

interface PessoaField {
  id: number;
  value: string;
}

export default function InformacoesPessoasRecolha() {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  // Estado para gerenciar campos dinâmicos
  const [pessoas, setPessoas] = useState<PessoaField[]>([
    { id: 1, value: '' },
    { id: 2, value: '' },
    { id: 3, value: '' },
    { id: 4, value: '' },
    { id: 5, value: '' },
    { id: 6, value: '' }
  ]);
  
  // Função para adicionar mais um campo
  const adicionarCampo = () => {
    const novoId = pessoas.length > 0 ? Math.max(...pessoas.map(p => p.id)) + 1 : 1;
    setPessoas([...pessoas, { id: novoId, value: '' }]);
  };
  
  // Função para atualizar o valor de um campo
  const handleChange = (id: number) => (e: ChangeEvent<HTMLInputElement>) => {
    setPessoas(pessoas.map(pessoa => 
      pessoa.id === id ? { ...pessoa, value: e.target.value } : pessoa
    ));
  };
  
  // Atualizar o Redux com os dados
  useEffect(() => {
    // Convertendo o array para o formato esperado pela ação do Redux
    const formData = pessoas.reduce((acc, pessoa) => {
      return {
        ...acc,
        [`pessoa${pessoa.id}`]: pessoa.value
      };
    }, {});
    
    dispatch({
      type: 'dadosPessoasRecolha',
      payload: { dadosPessoasRecolha: formData }
    });
  }, [pessoas, dispatch]);
  
  return (
    <Box className={classes.container}>
      <Typography variant="h5" className={classes.title}>
        PESSOAS RESPONSÁVEIS PELA RECOLHA
      </Typography>
      
      <Typography variant="subtitle1" className={classes.subtitle}>
        Nome da (s) pessoa (s) que realiza a recolha:
      </Typography>
      
      <Grid container spacing={3}>
        {pessoas.map((pessoa) => (
          <Grid item xs={12} md={6} key={pessoa.id}>
            <TextField
              type="text"
              label={`${pessoa.id}. Nome`}
              fullWidth
              size="small"
              variant="outlined"
              onChange={handleChange(pessoa.id)}
              value={pessoa.value}
            />
          </Grid>
        ))}
      </Grid>
      
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={adicionarCampo}
        className={classes.addButton}
      >
        Adicionar Pessoa
      </Button>
    </Box>
  );
}